import {brand} from "./brand";

export const v75 = {
    default: brand.default,
    subtle: brand.subtle,
    strong: brand.strong,
};
